import { useBreakpoints as _useBreakpoints } from "@vueuse/core";

const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 850,
  lg: 1200,
  xl: 1920
};

export default function useBreakpoints() {
  const breakpoints = _useBreakpoints(BREAKPOINTS, { ssrWidth: BREAKPOINTS.sm });
  const mobile = breakpoints.smaller('md');
  const desktop = computed(() => !mobile.value);

  return {
    mobile,
    desktop
  };
}